import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Privacy from "./pages/Privacy";
import TermsCondition from "./pages/TermsCondition";
import Landingpage from "./pages/Landingpage";
import CustomerPortal from "./pages/CustomerPortal";
import "./App.css";
import { Toaster } from "react-hot-toast";
import "aos/dist/aos.css";
import NotFound from "./pages/NotFound";
import Discoverpage from "./pages/Discoverpage";
import EnvironmentTag from "./components/Tag/EnvironmentTag";

// <Discoverpage /> === List of all providers will come as landing page
// <Landingpage /> === the main page showing what is tiffintap to get starting with business,  ( for providers to start their tiffin business)
// <Home /> === customer's url page where all the details of specific providers will be displayed (shared by provider to customer)

function App() {
  return (
    <>
      <BrowserRouter>
        <EnvironmentTag />
        <Routes>
          {/* Static routes FIRST */}
          <Route path="/" element={<Discoverpage />} />
          <Route path="/join-now" element={<Landingpage />} />
          <Route path="/privacy-policy" element={<Privacy />} />
          <Route path="/terms-of-service" element={<TermsCondition />} />
          <Route path="/c/:customerId" element={<CustomerPortal />} />
          {/* Dynamic slug AFTER static */}
          <Route
            path="/:provider"
            element={
              window.location.pathname
                .split("/")[1]
                ?.toLowerCase()
                .startsWith("ttsp") ? (
                <Home />
              ) : (
                <NotFound />
              )
            }
          />
          {/* <Route path="/:provider" element={<Home />} /> */}

          {/* 404 ALWAYS LAST */}
          <Route path="*" element={<NotFound />} />
          <Route path="/not-found" element={<NotFound />} />
        </Routes>
      </BrowserRouter>

      <Toaster position="top-right" reverseOrder={false} />
    </>
  );
}

export default App;
